const TONE_RULES = [
  { tone: "danger", pattern: /reject|lock|default|fail/i },
  { tone: "warn", pattern: /pending|re.?verification|extension/i },
  { tone: "success", pattern: /approv|active|closed|success/i }
];

function inferTone(title) {
  const rule = TONE_RULES.find((r) => r.pattern.test(title));
  return rule ? rule.tone : "accent";
}

export default function StatCard({ title, value, subtext, icon: Icon, index = 0, tone, isCurrency = false }) {
  // Validate real data — never display dummy fallback numbers
  let formatted = "0";
  if (value !== undefined && value !== null) {
    if (typeof value === "number") {
      if (!Number.isNaN(value)) {
        if (isCurrency) {
          formatted = `₹${Math.round(value).toLocaleString("en-IN")}`;
        } else {
          formatted = value.toLocaleString("en-IN", { maximumFractionDigits: 2 });
        }
      }
    } else {
      formatted = String(value);
    }
  }

  const resolvedTone = tone || inferTone(title);

  return (
    <div
      className={`stat-card${resolvedTone !== "accent" ? ` stat-card--${resolvedTone}` : ""}`}
      style={{ "--i": index }}
    >
      <div className="stat-card__top">
        <h4 className="stat-card__label">{title}</h4>
        {Icon && (
          <div className="stat-card__icon">
            <Icon />
          </div>
        )}
      </div>
      <p className="stat-card__value">{formatted}</p>
      {subtext && <p className="stat-card__sub">{subtext}</p>}
    </div>
  );
}
